// Support widget is now integrated into MobileHeader and desktop header
// This component is kept for backward compatibility but renders nothing
export const SupportWidget = () => {
  return null;
};
